import { combineReducers, createStore, compose } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { headerReducer } from '@stb-component-layout/Header/headerReducer';
import { authReducer } from './extra-reducer/auth';
import { parameterReducer } from './extra-reducer/system-parameter';
import { cityReducer } from './extra-reducer/city';
import { provinceReducer } from './extra-reducer/province';
import { SYNC_FROM_STORAGE } from './extra-constants/auth';

const reducers = combineReducers({
  header: headerReducer,
  auth: authReducer,
  paramater: parameterReducer,
  city: cityReducer,
  province: provinceReducer,
});
const persistConfig = {
  key: 'stb-web-app',
  storage,
  whitelist: ['auth', 'paramater'],
};

const composeEnhancer =
  // eslint-disable-next-line no-undef
  (process.env.NODE_ENV !== 'production' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null) ||
  compose;

const persistedReducer = persistReducer(persistConfig, reducers);

const store = createStore(persistedReducer, composeEnhancer());
const persistor = persistStore(store);

// Global storage event listener for cross-tab synchronization
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (event) => {
    if (event.key === 'persist:stb-web-app' && event.newValue) {
      try {
        const newPersistedState = JSON.parse(event.newValue);
        const currentState = store.getState();

        // Check if auth state has changed
        if (newPersistedState.auth) {
          const newAuthState = JSON.parse(newPersistedState.auth);
          const currentAuthState = currentState.auth;

          // Only sync login and session updates, NOT logout
          // This prevents tabs from logging each other out
          const isLogout =
            newAuthState.currentNavigation === 'auth' &&
            currentAuthState.currentNavigation === 'main';

          // Check if this is a login event or session update
          const isLogin =
            newAuthState.currentNavigation === 'main' &&
            currentAuthState.currentNavigation === 'auth';

          // Check if session data has been updated while staying logged in
          const hasSessionUpdates =
            newAuthState.currentNavigation === 'main' &&
            currentAuthState.currentNavigation === 'main' &&
            JSON.stringify(newAuthState.session) !== JSON.stringify(currentAuthState.session);

          if (isLogout) {
            // Ignore logout from other tabs to keep current tab logged in
            console.log('🚫 Cross-tab logout ignored - keeping current tab logged in', {
              from: 'Cross-tab storage event',
              action: 'LOGOUT_IGNORED',
              oldAuthState: currentAuthState,
              newAuthState: newAuthState,
              timestamp: new Date().toISOString(),
            });
          } else if (isLogin || hasSessionUpdates) {
            // Sync login and session updates across tabs
            console.log('🔄 Cross-tab sync triggered - updating auth state', {
              from: 'Cross-tab storage event',
              action: isLogin ? 'LOGIN_SYNC' : 'SESSION_UPDATE_SYNC',
              oldAuthState: currentAuthState,
              newAuthState: newAuthState,
              timestamp: new Date().toISOString(),
            });

            // Dispatch sync action to update the current tab's state
            store.dispatch({
              type: SYNC_FROM_STORAGE,
              payload: newAuthState,
            });
          }
        }
      } catch (error) {
        console.error('Error syncing from localStorage:', error);
      }
    }
  });
}

export { reducers, persistedReducer, persistor };

export default store;
